import { createFileRoute, Link, Outlet, useMatches } from '@tanstack/react-router'
import {
  Phone, Voicemail, MessageSquare, User, TrendingUp, Brain, Settings2,
} from 'lucide-react'
import PageTransition from '@/components/PageTransition'
import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'

const PHONE_TABS = [
  { to: '/phone/calls', segment: 'calls', label: 'phoneDashboard:calls', icon: Phone },
  { to: '/phone/voicemail', segment: 'voicemail', label: 'phoneDashboard:voicemail', icon: Voicemail },
  { to: '/phone/sms', segment: 'sms', label: 'phoneDashboard:sms', icon: MessageSquare },
  { to: '/phone/agents', segment: 'agents', label: 'phoneDashboard:agents', icon: User },
  { to: '/phone/analytics', segment: 'analytics', label: 'phoneDashboard:analytics', icon: TrendingUp },
  { to: '/phone/routing', segment: 'routing', label: 'phoneDashboard:routing', icon: Brain },
  { to: '/phone/config', segment: 'config', label: 'phoneDashboard:config', icon: Settings2 },
] as const

export const Route = createFileRoute('/_authenticated/phone')({
  component: PhoneLayout,
})

function PhoneLayout() {
  const { t } = useTranslation()
  const matches = useMatches()
  const activeTab = matches[matches.length - 1]?.routeId?.split('/').pop() ?? 'calls'

  return (
    <PageTransition>
      <div className="space-y-6 p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-semibold tracking-tight">{t('phoneDashboard:phone')}</h1>
            <p className="text-sm text-muted-foreground">{t('phoneDashboard:callsSmsIvrAndAiVoiceManagement')}</p>
          </div>
        </div>

        <div className="flex gap-1 border-b">
          {PHONE_TABS.map(tab => (
            <Link
              key={tab.to}
              to={tab.to}
              className={cn(
                'flex items-center gap-1.5 px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors',
                activeTab === tab.segment
                  ? 'border-primary text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground',
              )}
            >
              <tab.icon className="w-4 h-4" />
              {t(tab.label)}
            </Link>
          ))}
        </div>

        <Outlet />
      </div>
    </PageTransition>
  )
}
